import React from "react"
import Filters from "@bodeboca/algolia/components/filters/filters"
import MobileFilters from "@bodeboca/algolia/components/filters/mobile-filters"
import CustomSort from "@bodeboca/algolia/components/search/sort"
import CustomHits from "@bodeboca/algolia/components/hits"
import CustomSearch from "@bodeboca/algolia/components/search/custom_search"
import CustomPagination from "@bodeboca/algolia/components/pagination"
import Stats from "@bodeboca/algolia/components/search/stats"


const InstantSearchContent = ({}) => {
  return (<>
    <CustomSearch/>
    <MobileFilters/>
    <CustomSort/>
    <Filters/>
    <Stats className={"onlymobile"}/>
    <div className="bb-product-filters-after"></div>
    <div id={"venta-main-wrapper"}>
      <div id={"venta-main"}>
        <CustomHits/>
        <div className="clear"/>
        <div className={"item-list"}>
          <CustomPagination/>
        </div>
      </div>
    </div>
  </>)
}

export default InstantSearchContent
